import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import {
  IGetToken,
  IUserData,
} from '../../modules/authorization/interfaces/authorization-interfaces';
import { DataType } from '../../modules/usersPage/interfaces/interfaces';

export const baseUrl = 'http://itm-demo-parser2.bi.n3zdrav.ru/';

export const authService = createApi({
  reducerPath: 'authService',
  baseQuery: fetchBaseQuery({ baseUrl: baseUrl, credentials: 'include' }),
  tagTypes: ['UsersTables'],
  endpoints: (build) => ({
    getOAuth2: build.query<{ authorization_url: string }, never>({
      query: () => ({
        url: '/auth/xpath/authorize',
      }),
      providesTags: () => ['UsersTables'],
    }),
    getSignInToken: build.mutation<IUserData, IGetToken>({
      query: (data) => ({
        url: 'auth/login',
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Access-Control-Allow-Origin': 'http://itm-demo-parser2.bi.n3zdrav.ru',
        },
        body: `username=${data.login}&password=${data.password}`,
      }),
    }),
    logOut: build.mutation({
      query: () => ({
        url: 'auth/logout',
        method: 'POST',
      }),
    }),
    getAllUsers: build.query<DataType[], { skip: number; limit: number }>({
      query: ({ skip, limit }) => ({
        url: 'users/users_all',
        params: {
          skip,
          limit,
        },
      }),
      providesTags: () => ['UsersTables'],
    }),
    editUser: build.mutation<DataType, DataType>({
      query: (data) => ({
        url: `users/users/${data.id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['UsersTables'],
    }),
    deleteUser: build.mutation<number, string>({
      query: (id) => ({
        url: `users/users/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['UsersTables'],
    }),
    addUser: build.mutation<DataType, DataType>({
      query: (body) => ({
        url: 'auth/register',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['UsersTables'],
    }),
  }),
});
